import { Link } from "react-router-dom";
import { useJournal } from "../lib/journal.jsx";
import { useAuth } from "../lib/auth.jsx";
import { techniquesById } from "../data/techniques.js";
import { Icon } from "../components/Icons.jsx";
import Seo from "../components/Seo.jsx";

export default function Journal() {
  const { saved, entries, useRemote } = useJournal();
  const { user, isSupabaseConfigured } = useAuth();

  return (
    <>
      <Seo
        title="Your Practice Journal · Simple Meditation World"
        description="Saved techniques and personal reflections."
        path="/journal"
      />
      <section className="section-ivory" style={{ paddingTop: 80 }}>
        <div className="container">
          <span className="eyebrow">Your space</span>
          <h1 style={{ fontFamily: "var(--serif)", fontWeight: 400, fontSize: "clamp(32px, 4.5vw, 56px)", marginTop: 14 }}>
            Your <em>Practice Journal</em>
          </h1>
          <p style={{ color: "var(--muted)", maxWidth: 600, marginTop: 14 }}>
            {useRemote
              ? "Saved to your account. Synced across devices."
              : isSupabaseConfigured && !user
                ? <>Saved locally on this device. <Link to="/sign-in" style={{ color: "var(--copper)" }}>Sign in</Link> to sync across devices.</>
                : "Saved locally on this device."}
          </p>

          <h2 style={{ fontFamily: "var(--serif)", fontWeight: 400, marginTop: 50, marginBottom: 20 }}>
            Saved Techniques <span style={{ color: "var(--muted)", fontSize: 16 }}>({saved.length})</span>
          </h2>
          {saved.length === 0 ? (
            <p style={{ color: "var(--muted)" }}>
              You haven't saved any techniques yet. <Link to="/techniques" style={{ color: "var(--copper)" }}>Browse the 112</Link>.
            </p>
          ) : (
            <div className="techniques-grid">
              {saved.map((id) => {
                const t = techniquesById[id];
                if (!t) return null;
                return (
                  <Link key={id} to={`/technique/${t.id}`} className="t-card">
                    <div className="t-card-top">
                      <span className="t-num">{String(t.id).padStart(3, "0")}</span>
                    </div>
                    <h3>{t.title}</h3>
                    <p>{t.modern}</p>
                  </Link>
                );
              })}
            </div>
          )}

          <h2 style={{ fontFamily: "var(--serif)", fontWeight: 400, marginTop: 60, marginBottom: 20 }}>
            Reflections <span style={{ color: "var(--muted)", fontSize: 16 }}>({entries.length})</span>
          </h2>
          {entries.length === 0 ? (
            <p style={{ color: "var(--muted)" }}>No reflections yet. After each practice, write one line — it's enough.</p>
          ) : (
            <div style={{ display: "grid", gap: 14, maxWidth: 760 }}>
              {entries.map((e) => {
                const t = techniquesById[e.technique_id];
                const date = new Date(e.created_at);
                return (
                  <div key={e.id} className="journal-mock" style={{ transform: "none", margin: 0 }}>
                    <div className="jm-date">{date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" }).toUpperCase()}</div>
                    <div className="jm-title">{t ? t.title : `Technique ${e.technique_id}`}</div>
                    <div className="jm-note">"{e.note}"</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
